module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"report":"Rapport"},"en-BE":{"report":"Report"},"fr-BE":{"report":"Rapport"}}')
  delete Component.options._Ctor
}
